import React, { useState, useEffect } from 'react';
import { 
    Grid, 
    Box,
    Chip,
    Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, useParams} from "react-router-dom";
import config from 'config';
import SearchForm from 'components/SearchForm';
import { useSelector } from 'react-redux';
import apiService from 'services/apiService';
import { reportError } from 'actions/errorActions';
import { translation } from 'utils/translate';
import Tip from 'components/Tip';
import { themePageManager } from 'components/ThemePage/ThemePage';

const LinkButton = styled(Button)(() => ({
  flexDirection: 'row',
  marginLeft: 2,
  textTransform: 'none',
  color: 'black',
  lineHeight: '18px',
  fontWeight: 'bold',
  textDecoration: 'underline',
  textDecorationThickness: 1,
  height: 28,
  textAlign: 'left',
  '&:hover': {
    backgroundColor: 'unset',
    borderColor: 'unset',
    boxShadow: 'unset',
    textDecoration: 'underline',
    textDecorationThickness: 1,
    color: 'hsl(202, 67%, 28%)',
  },
}));

const SearchForEveryone = () => {
    const { docGroup } = useParams();
    const activeForm = docGroup || config.defaultDocGroup
    const fullScreen = useSelector((store) => store.searchFormFullScreen)
    const lang = useSelector((store) => store.lang)
    const [chips, setChips] = useState([])
    const [themeChips, setThemeChips] = useState([]);

    // fetch data for keyword chips
    useEffect(() => {
      const fetchData = async () => {
        let keywords = null;
        try {
          keywords = await apiService.getKeywords(lang);
        } catch (error) {
          reportError(error);
          return;
        }
        if (keywords?.response) {
          setChips(keywords.response);
        }
      };

      setThemeChips(
        themePageManager.chips[lang] ?? []
      );

      fetchData();
    }, [lang]);

    const handleChipClick = (chip) => {
        if (chip){
            const link = '?docGroup=hallituksen_esitykset&term='+chip[0]+'&sort=score&lang='+lang
            window.location.href=link
        }
    }

    const handleThemeChipClick = (chip) => {
      if (!chip) return;
      const path = lang === "se" ? "/teman/" : "/teemat/";
      window.location.href = path + chip;
    };

    //Pikalinkit:
    //Uusimmat:
    const handleLatestOnClick = async () => {
        let result = null
        try{
            result = await apiService.getLatests()
        }catch (error) {
            reportError(error)
            return
        }
        if (result?.response) {
            let resultString = result.response.toString()
            resultString= resultString.replaceAll(":", "%3A")
            resultString= resultString.replaceAll("/","%2F")
            resultString=resultString.replaceAll(",","%2C")
            const link = '?docGroup=lausuntokierros&sort=alpha_desc&prefilters={"tunnus"%3A"'+resultString+'"}&lang='+lang
            window.location.href=link
        }
    }
    //Eduskunnassa:
    const handleEduskunnassa = async () => {
        let result = null
        try{
            result = await apiService.getLatestsHallituksenEsitykset()   
        }catch (error) {
            reportError(error)
            return
        }
        if (result?.response) {
            let resultString = result.response.toString()
            resultString= resultString.replaceAll("/","%2F") 
            resultString=resultString.replaceAll(",","%2C")
            const link = '?docGroup=lausuntokierros&sort=alpha_desc&prefilters={"tunnus"%3A"'+resultString+'"}&lang='+lang
            window.location.href=link
        }
    }
    //Osallistu:
    const handleOngoing = async () => {
        let result = null
        try{
            result = await apiService.getOngoing()    
        }catch (error) {
            reportError(error)
            return
        }
        let resultArray=[]
        if (result?.response) {
            result.response.map((result) => resultArray.push(result[0]))
            let resultString = resultArray.toString()
            resultString = resultString.replaceAll(":", "%3A")  
            resultString = resultString.replaceAll("/","%2F")
            const link = '?docGroup=all&sort=alpha_desc&prefilters={"tunnus"%3A"'+resultString+'"}&lang='+lang
            window.location.href=link
        }
    }
    //Oikopolut hakuun:
    //Uusimmat hallituksen esitykset:
    const handleLatestGovernmentPresentations = () =>{
        const link = '?docGroup=hallituksen_esitykset&&sort=date_desc&lang='+lang
        window.location.href=link
    }
    //Talousarviot:
    const handleBudgets = () =>{
        const link = '?docGroup=hallituksen_esitykset&sort=date_desc&prefilters=%7B%22talousarviot%22%3A%22strictly%22%7D&lang='+lang
        window.location.href=link
    }
    //Eniten eduskunnassa keskustellut:
    const handleStatements = async () => {
        let result = null
        try{
            result = await apiService.getStatements()    
        }catch (error) {
            reportError(error)
            return
        }
        let resultArray=[]
        if (result?.response) {
            result.response.map((result) => resultArray.push(result[0]))
            resultArray = resultArray.reverse()
            let resultString = resultArray.toString()
            resultString = resultString.replaceAll("/","%2F")
            const link = '?docGroup=all&sort=alpha_desc&prefilters={"tunnus"%3A"'+resultString+'"}&lang='+lang
            window.location.href=link
        }
    }

    return(
        <Grid container spacing={5}>
            <Grid item  xs={12} sm={12} md={fullScreen? 12 : 8 } lg={fullScreen? 12 : 8}>
                {fullScreen &&
                    <div>
                        <h1>{translation("Hakutulokset", lang)}</h1>
                    </div>
                }
                {fullScreen === false &&
                    <>
                        <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: 0,
                                paddingBottom: '0.5px', 
                            }}>
                            <img 
                                alt="Lakita"
                                src="/lakita.svg"
                                width="225"
                            />
                        </div>
                        <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: 0,
                                paddingBottom: '0.5px', 
                            }}>
                            <h1 sx={{marginBottom: -10 }}>{translation("site_name", lang)}</h1>
                        </div>
                        <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '1rem',
                            }}
                            >
                            <p>{translation("Lakitutka_intro_for_everyone", lang)}</p>
                        </div>
                    </>
                }
                <div style={{
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start', 
                    }}>
                    <SearchForm docGroup={activeForm}/>
                </div> 
                {!fullScreen &&
                <div  style={{
                            marginRight: '1rem',
                            marginTop: '1rem',
                        }}>
                    <h2 style={{
                        fontWeight: 600, 
                        marginLeft: 0,
                        marginTop: 0
                    }}>{translation("tarkastele_aihealueittain", lang)}</h2>
                    {chips.map((chip,key)=>
                        <Chip
                            key={key}
                            label={chip[0]}
                            sx={{
                                color: "#070707",
                                backgroundColor: "#f4f5f5",
                                border: "2px solid #070707",
                                padding: "3px",
                                fontWeight: "bold",
                                margin: "3px",
                            }}
                            clickable
                            variant="outlined"
                            onClick={()=> handleChipClick(chip)}
                            
                        />)
                    }
                    {themeChips.length > 0 && (
                      <>
                        <p style={{ fontWeight: 600 }}>
                          {translation("themepages", "chips_title", lang)}
                          <Tip title={translation("themepages", "chips_tooltip", lang)}>
                            <span className="tooltip-help tippable"></span>
                          </Tip>
                        </p>
                        {themeChips.map(({ chip, backgroundColor }) => (
                          <Chip
                            key={chip}
                            label={chip}
                            sx={{
                              color: "#070707",
                              backgroundColor: backgroundColor,
                              border: "2px solid #070707",
                              padding: "3px",
                              fontWeight: "bold",
                              margin: "3px",
                              "&:hover": {
                                // needs !important, otherwise MuiChip style overrides it
                                backgroundColor: backgroundColor + " !important",
                              }
                            }}
                            clickable
                            variant="outlined"
                            onClick={() => handleThemeChipClick(chip)}
                          />)
                        )}
                      </>
                    )}
                </div>
                }
            </Grid>
            {!fullScreen &&
            <Grid item  xs={12} sm={12} md={4} lg={4}>
                <Grid>
                    <div>
                        <h2 sx={{
                            fontWeight: 600, 
                            marginLeft: 0,
                            marginTop: 0
                        }}>{translation("pikalinkit", lang)}</h2>
                    </div>
                    <Grid>
                        <div>
                            <Box sx={{ flexGrow: 1,
                                    overflow: 'hidden',
                                    backgroundColor: "#ffcae9",
                                    marginBottom: 2,  
                                    paddingBottom: "2rem",
                                    paddingRight: "2rem",
                                    fontSize: 14}} >
                                <div style={{ display: 'flex' }}>
                                    <div style={{
                                            marginLeft: '2rem',
                                            marginTop: '5%',
                                        }}>
                                        <img
                                            alt="logo"
                                            src="/hankkeet_icon.svg"
                                        />
                                    </div>
                                    <div style={{
                                            marginLeft: '5%',
                                            marginTop: '5%',
                                        }}>
                                        <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}>
                                            <h3 style={{ fontWeight: 700 }}>{translation("käynnissä_olevat_hankkeet", lang)}</h3>
                                        </div>
                                   
                                        <div  style={{ display: 'flex' }}>
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                                sx={{ display: 'flex', flexDirection: 'row' }}
                                            ></img>
                                            <LinkButton
                                                onClick={handleLatestOnClick}
                                            >
                                                {translation("uusimmat",lang)}
                                            </LinkButton>
                                        </div>
                                        <div  style={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                                sx={{ display: 'flex', flexDirection: 'row' }}
                                            ></img>
                                            <LinkButton
                                                onClick={handleEduskunnassa}
                                                >{translation("eduskunnassa",lang)}
                                            </LinkButton> 
                                        </div>
                                        <div  style={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                                sx={{ display: 'flex', flexDirection: 'row' }}
                                            ></img>
                                            <LinkButton
                                                onClick={handleOngoing}
                                                >{translation("osallistu", lang)}
                                            </LinkButton> 
                                        </div>
                                    </div>
                                </div>
                            </Box>       
                        </div> 
                    </Grid>
                        <Grid>
                            <div>
                                <Box sx={{  
                                        flexGrow: 1,
                                        overflow: 'hidden',
                                        backgroundColor: "#ACE7CA",
                                        marginBottom: "20px",
                                        paddingBottom: "2rem",
                                        paddingRight: "2rem",
                                        fontSize: 14}} >
                                    <div  style={{ display: 'flex' }}>
                                        <div style={{
                                                marginLeft: '5%',
                                                marginTop: '5%',
                                            }}>
                                            <img
                                                alt="logo"
                                                src="/oikopolut_icon.svg"
                                        />
                                        </div>
                                        <div style={{
                                                marginLeft: '5%',
                                                marginTop: '5%',
                                            }}>
                                            <div 
                                                 >
                                                <h3 style={{ fontWeight: 700 }}>{translation("oikopolut_hakuun",lang)}</h3>
                                            </div>
                                            <div  style={{ display: 'flex' }}>
                                                <img
                                                    alt="arrow"
                                                    src="/hero_arrow_right.svg"
                                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                                ></img>
                                                <LinkButton 
                                                    sx={{
                                                        marginLeft: '2px', 
                                                        textTransform: 'none',
                                                        color: 'black',
                                                        lineHeight: '18px',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        height: 28,
                                                        textAlign: 'left',
                                                        '&:hover': {
                                                        backgroundColor: 'unset',
                                                        borderColor: 'unset',
                                                        boxShadow: 'unset',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        color: 'hsl(202, 67%, 28%)',
                                                        },
                                                    }}
                                                    onClick={handleLatestGovernmentPresentations}
                                                    >{translation("uusimmat_he", lang)}
                                                </LinkButton>  
                                            </div>
                                            <div  style={{ display: 'flex' }}> 
                                                <img
                                                    alt="arrow"
                                                    src="/hero_arrow_right.svg"
                                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                                ></img>
                                                <LinkButton 
                                                    sx={{
                                                        marginLeft: '2px', 
                                                        textTransform: 'none',
                                                        color: 'black',
                                                        lineHeight: '18px',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        height: 28,
                                                        textAlign: 'left',
                                                        '&:hover': {
                                                        backgroundColor: 'unset',
                                                        borderColor: 'unset',
                                                        boxShadow: 'unset',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        color: 'hsl(202, 67%, 28%)',
                                                        },
                                                    }}
                                                    onClick={handleBudgets}
                                                    >{translation("talousarviot", lang)}
                                                </LinkButton> 
                                            </div>
                                            <div style={{ display: 'flex' }}> 
                                                <img
                                                    alt="arrow"
                                                    src="/hero_arrow_right.svg"
                                                ></img>
                                                <LinkButton 
                                                    sx={{
                                                        marginLeft: '2px', 
                                                        textTransform: 'none',
                                                        color: 'black',
                                                        lineHeight: '18px',
                                                        fontWeight: 'bold',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        height: 28,
                                                        textAlign: 'left',
                                                        '&:hover': {
                                                        backgroundColor: 'unset',
                                                        borderColor: 'unset',
                                                        boxShadow: 'unset',
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        color: 'hsl(202, 67%, 28%)',
                                                        },
                                                    }}
                                                    onClick={handleStatements}
                                                    >{translation("eniten_eduskunnassa_keskustellut", lang)}
                                                </LinkButton> 
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </div> 
                        </Grid>
                    <Grid>
                        <div>
                            <Box sx={{ 
                                    flexGrow: 1,
                                    overflow: 'hidden',
                                    backgroundColor: "#FFED65",
                                    marginBottom: '20px',
                                    paddingBottom: "2rem",
                                    paddingRight: "2rem",
                                    fontSize: 14,
                                }}>
                                <div  style={{ display: 'flex'}}>
                                    <div style={{
                                            marginLeft: '5%',
                                            marginTop: '5%',
                                        }}>
                                        <img
                                            alt="logo"
                                            src="/opi_icon.svg"
                                        />
                                    </div>
                                    <div style={{
                                            marginLeft: '5%',
                                            marginTop: '5%',
                                        }}>
                                        <div>
                                            <h3 style={{ fontWeight: 'bold' }}>{translation("opi_miten_lait_syntyvät", lang)}</h3>
                                        </div>
                                        <div style={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                            ></img>
                                            <a style={{
                                                    color: 'black',
                                                    fontWeight: 'bold',
                                                    textDecoration: 'underline',
                                                    textDecorationThickness: 1,
                                                    marginLeft: '10px',
                                                    marginTop: '5px',
                                                }}
                                                href="https://www.youtube.com/watch?v=KdIMfFCV2Mw/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {translation("video_näin_lait_synytvät", lang)}
                                            </a>
                                        </div>
                                        {(lang === 'se') ?
                                            <div  style={{ display: 'flex' }}> 
                                                <img
                                                    alt="arrow"
                                                    src="/hero_arrow_right.svg"
                                                ></img>
                                                <a
                                                     style={{
                                                        color: 'black',
                                                        fontWeight: '700',  
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        marginLeft: '10px',
                                                        marginTop: '5px',
                                                    }}
                                                    href="https://www.youtube.com/watch?v=2jU6QArc5LY"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {translation("video_näin_lait_syntyvät_en", lang)}
                                                </a>
                                            </div>
                                            :<></>
                                        }
                                        <div  sx={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                            ></img>
                                            <a
                                                 style={{
                                                    color: 'black',
                                                    fontWeight: '700',  
                                                    textDecoration: 'underline',
                                                    textDecorationThickness: 1,
                                                    marginLeft: '10px',
                                                    marginTop: '5px',
                                                    }}
                                                href="https://www.youtube.com/watch?v=5oFocGzFHhs"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {translation("video_kuuleminen_lainvalmistelussa", lang)}
                                            </a>
                                        </div>
                                        {(lang === 'se') ?
                                            <div  style={{ display: 'flex' }}> 
                                                <img
                                                    alt="arrow"
                                                    src="/hero_arrow_right.svg"
                                                ></img>
                                                <a
                                                     style={{
                                                        color: 'black',
                                                        fontWeight: '700',  
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        marginLeft: '10px',
                                                        marginTop: '5px',
                                                    }}
                                                    href="https://www.youtube.com/watch?v=CrtleyvQcjw"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {translation("video_kuuleminen_lainvalmistelussa_en", lang)}
                                                </a>
                                            </div>
                                            :<></>
                                        }
                                        <div sx={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                            ></img>
                                            <a
                                                 style={{
                                                    color: 'black',
                                                    fontWeight: '700',  
                                                    textDecoration: 'underline',
                                                    textDecorationThickness: 1,
                                                    marginLeft: '10px',
                                                    marginTop: '5px',
                                                    }}
                                                href="https://digicampus.fi/course/view.php?id=4775"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {translation("mooc", lang)}
                                            </a>
                                        </div>
                                        <div  sx={{ display: 'flex' }}> 
                                            <img
                                                alt="arrow"
                                                src="/hero_arrow_right.svg"
                                            ></img>
                                            <Link  style={{
                                                        color: 'black',
                                                        fontWeight: '700',  
                                                        textDecoration: 'underline',
                                                        textDecorationThickness: 1,
                                                        marginLeft: '10px',
                                                        marginTop: '5px',
                                                    }}
                                                to="/dictionary"
                                                >{translation("lainvalmistelun_sanakirja", lang)}
                                            </Link> 
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </div> 
                    </Grid>
                </Grid>
            </Grid>
            }
        </Grid>
    )
}
export default SearchForEveryone;
